import { faArrowUpRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";

import { item } from "~/components/site/layout";

type Props = Readonly<{
  heading: string;
  children: React.ReactNode;
  external?: boolean;
  className?: string;
}>;

export function Callout({
  heading,
  children,
  external = true,
  className = "",
}: Props): JSX.Element {
  return (
    <div className={`p-6 md:p-8 border-b border-primary ${className}`}>
      <motion.div variants={item}>
        <div className="eyebrow flex items-center gap-x-2 !mb-3">
          {heading}
          {external && (
            <FontAwesomeIcon className="h-5 w-5" icon={faArrowUpRight} />
          )}
        </div>
        {children}
      </motion.div>
    </div>
  );
}
